// extracted by mini-css-extract-plugin
export default {"text_curriculum_secondary":"styles_text_curriculum_secondary__qim8k"};